import { MessagesView } from "../components/MessagesView";

export function ClientMessagesPage() {
  return <MessagesView mode="client" />;
}
